import { FETCH_USER, USER_EDITING } from '../actions/UserActions';

// INITIALIZE STATE
const initialState = {
    user: null,
    fetching: false,
    fetched: false,
    failed: false,
    isEditing: false,
};

// REDUCER
export const UserReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USER}_PENDING`:
            return {
                ...state,
                user: null,
                fetching: true,
                fetched: false,
                failed: false,
                isEditing: false,
            };
        case `${FETCH_USER}_FULFILLED`:
            return {
                ...state,
                user: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
                isEditing: false,
            };
        case `${FETCH_USER}_REJECTED`:
            return {
                ...state,
                user: null,
                fetching: false,
                fetched: false,
                failed: true,
                isEditing: false,
            };
        case USER_EDITING:
            return {
                ...state,
                isEditing: action.payload,
            };
        default:
            return state;
    }
};
